module.exports = __webpack_public_path__ + "img/map.405932f8.png";